export default __webpack_public_path__ + "static/media/error_404.c089d0a5.svg";